"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var styled_1 = __importDefault(require("@emotion/styled"));

var Link_1 = require("./Icons/Link");

var sizeMap = {
  h1: 'text-5xl md:text-6xl mt-14 md:mt-16',
  h2: 'text-4xl md:text-5xl mt-12 md:mt-14',
  h3: 'text-3xl md:text-4xl mt-10 md:mt-12',
  h4: 'text-2xl md:text-3xl mt-8 md:mt-10 font-thin',
  h5: 'text-xl md:text-2xl mt-6 md:mt-8 font-thin',
  h6: 'text-lg md:text-xl mt-4 md:mt-6 font-thin'
};

function Heading(_a) {
  var size = _a.size,
      mask = _a.mask,
      as = _a.as,
      children = _a.children,
      className = _a.className,
      style = _a.style;
  return react_1.default.createElement(as || size, {
    children: children,
    className: classnames_1.default('font-thin', sizeMap[mask || as || size], className),
    style: style
  });
}

exports.Heading = Heading;
var Element = styled_1.default(Heading)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  z-index: 0;\n  display: flex;\n  align-items: center;\n  left: -30px;\n  \n  @media only screen and (max-width: 800px) {\n    left: -5px;\n  }\n\n  span.anchor {\n    position: absolute;\n    margin-top: ", "px;\n    padding-bottom: 6rem;\n    display: block;\n  }\n\n  a {\n    margin-right: 0.5rem;\n    opacity: 0.3;\n    transition: opacity 0.2s;\n    border: none;\n    text-decoration: none;\n\n    &:hover {\n      opacity: 1;\n      border: none;\n      text-decoration: none;\n    }\n  }\n"], ["\n  position: relative;\n  z-index: 0;\n  display: flex;\n  align-items: center;\n  left: -30px;\n  \n  @media only screen and (max-width: 800px) {\n    left: -5px;\n  }\n\n  span.anchor {\n    position: absolute;\n    margin-top: ", "px;\n    padding-bottom: 6rem;\n    display: block;\n  }\n\n  a {\n    margin-right: 0.5rem;\n    opacity: 0.3;\n    transition: opacity 0.2s;\n    border: none;\n    text-decoration: none;\n\n    &:hover {\n      opacity: 1;\n      border: none;\n      text-decoration: none;\n    }\n  }\n"])), function (props) {
  return props.offset || 0;
});

function HeadingLink(_a) {
  var children = _a.children,
      id = _a.id,
      offset = _a.offset,
      props = __rest(_a, ["children", "id", "offset"]);

  return react_1.default.createElement(Element, __assign({}, props, {
    offset: offset
  }), react_1.default.createElement("span", {
    className: "anchor",
    id: id
  }), react_1.default.createElement("a", {
    href: "#" + id
  }, react_1.default.createElement(Link_1.Link, {
    size: 20
  })), children);
}

exports.HeadingLink = HeadingLink;
var templateObject_1;